// Code by Faisal Akram

document.addEventListener('DOMContentLoaded', function () {
  /*
   * 1) Move Easify/TPO block above the buy buttons
   * (data-block-id may be different; adjust if needed)
   */
  var tpoBlock = document.querySelector(
    '.product-info__block-item[data-block-id^="easify_options_easify_product_options_"]'
  );
  var buyButtonsWrapper = document.querySelector('.product-info__buy-buttons');

  if (tpoBlock && buyButtonsWrapper) {
    buyButtonsWrapper.prepend(tpoBlock);
  }

  /*
   * 2) Product description "Read more / Read less"
   * Requires HTML with #product-description and #toggle-description.
   */
  var descriptionDiv = document.getElementById('product-description');
  var toggleButton   = document.getElementById('toggle-description');

  if (descriptionDiv && toggleButton) {
    descriptionDiv.style.overflow = 'hidden';
    descriptionDiv.style.display = '-webkit-box';
    descriptionDiv.style.webkitBoxOrient = 'vertical';
    descriptionDiv.style.webkitLineClamp = 5;

    var isExpanded = false;

    window.toggleDescription = function () {
      if (isExpanded) {
        descriptionDiv.style.webkitLineClamp = 5;
        toggleButton.textContent = 'Read More';
      } else {
        descriptionDiv.style.webkitLineClamp = 'unset';
        toggleButton.textContent = 'Read Less';
      }
      isExpanded = !isExpanded;
    };
  }

  /*
   * 3) "Start Conversation with Rep" modal
   * (same behavior as before, just moved into this file)
   */
  var openBtn  = document.getElementById('product-start-btn');
  var modal    = document.getElementById('product-start-modal');
  var closeBtn = document.getElementById('product-start-modal-close');
  var backdrop = document.getElementById('product-start-modal-backdrop');
  var form     = document.getElementById('product-modal-contact-form');

  var fields   = document.getElementById('product-contact-fields');
  var success  = document.getElementById('product-contact-success');
  var errorsUi = document.getElementById('product-contact-errors');
  var closeNow = document.getElementById('product-contact-close-now');

  function openModal() {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  function showSuccess() {
    if (fields)  fields.style.display  = 'none';
    if (success) success.style.display = 'block';
    if (errorsUi) errorsUi.style.display = 'none';

    // auto close after a short delay
    setTimeout(closeModal, 4000);
  }

  function showErrors() {
    if (errorsUi) errorsUi.style.display = 'block';
  }

  if (openBtn && modal) {
    openBtn.addEventListener('click', openModal);
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }
  if (backdrop) {
    backdrop.addEventListener('click', closeModal);
  }
  if (closeNow) {
    closeNow.addEventListener('click', closeModal);
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (errorsUi) errorsUi.style.display = 'none';

      var formData = new FormData(form);
      var action =
        form.getAttribute('action') ||
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
          ? window.Shopify.routes.root + 'contact#contact_form'
          : '/contact#contact_form');

      fetch(action, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'text/html' },
        redirect: 'follow',
      })
        .then(function (res) {
          // Shopify contact form usually redirects with ?contact_posted=true
          var ok =
            res &&
            res.url &&
            res.url.indexOf('contact_posted=true') !== -1;

          if (ok) {
            showSuccess();
          } else {
            showErrors();
          }
        })
        .catch(function () {
          showErrors();
        });
    });
  }

  /*
   * 4) Re-implement old jQuery behavior for "Buy Now / No Personalization"
   * and Easify block / quantity block / size inputs.
   */

  var buyNowBtn          = document.getElementById('buy_now_personalization');
  var buyNowWrapper      = document.getElementById('buy_now_personalization_div');
  var easifyOptions      = document.querySelector('.easify-product-options');
  var quantityBlockItem  = document.querySelector(
    '.product-info__block-item[data-block-id="quantity_selector"]'
  );
  var quantityInner      = document.querySelector('.product-info__quantity-selector');
  var buyButtonsElement  = document.querySelector('buy-buttons.buy-buttons');

  // Move quantity block into Easify container (same as old code)
  var easifyContainer =
    document.querySelector(
      '#shopify-block-AbU9ud053RGZjRXBLW__easify_options_easify_product_options_zxtCkM'
    ) || tpoBlock; // fallback to the TPO block if needed

  if (easifyContainer && quantityBlockItem) {
    easifyContainer.appendChild(quantityBlockItem);
  }

  // Initial state: hide Easify, buy-buttons element and quantity block
  if (easifyOptions) {
    easifyOptions.style.display = 'none';
  }
  if (buyButtonsElement) {
    buyButtonsElement.style.display = 'none';
  }
  if (quantityBlockItem) {
    quantityBlockItem.style.display = 'none';
  }
function togglePersonalizationView() {
    
    // 1. Add class to parent (CSS handles the hiding/showing)
    var productInfo = document.querySelector('.product-info') || document.body;
    productInfo.classList.toggle('hide-customize-buttons');

    // 2. Toggle Easify Options (Force them to Open)
    if (easifyOptions) {
        if (easifyOptions.style.display === 'none') {
             easifyOptions.style.display = 'block'; 
        } else {
             easifyOptions.style.display = 'none';
        }
    }

    // 3. Toggle Native Buy Buttons
    if (buyButtonsElement) {
      buyButtonsElement.style.display =
        buyButtonsElement.style.display === 'none' ? '' : 'none';
    }

    // 4. Toggle Quantity Block
    if (quantityBlockItem) {
      quantityBlockItem.style.display =
        quantityBlockItem.style.display === 'none' ? '' : 'none';
    }

    // 5. Add Close Button
    if (quantityInner && !quantityInner.querySelector('button.close-btn')) {
      var closeButton = document.createElement('button');
      closeButton.className = 'close-btn';
      closeButton.type = 'button';
      closeButton.textContent = 'Close';
      quantityInner.appendChild(closeButton);

      closeButton.addEventListener('click', function () {
        togglePersonalizationView(); 
        closeButton.remove();        
      });
    }
  }

  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function (e) {
      e.preventDefault();
      togglePersonalizationView();
    });
  }

  // 5) Size inputs background-color change (old jQuery behavior)
  setTimeout(function () {
    var sizeInputs = document.querySelectorAll(
      '.tpo_option-set-wrapper.tpo_has-option-set .tpo_option-container.tpo_flex-25 input'
    );
    sizeInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.value && input.value.trim() !== '') {
          input.style.backgroundColor = '#dddddd';
        } else {
          input.style.backgroundColor = '';
        }
      });
    });
  }, 2500);

  /*
   * 6) MISSING ITEM ADDED:
   * Section Padding Fix for Gradient Sections (Re-implementing logic from old theme.liquid)
   */
  if (window.location.pathname.includes('/collections/') || window.location.pathname.includes('/products/')) {
    var sections = document.querySelectorAll('.section.section-full.bg-gradient');
    sections.forEach(function(section) {
      section.style.paddingBottom = '0';
    });
  }

});
// Code by Faisal Akram Ends